import { useState, useEffect, useCallback } from "react";
import axios from "axios";
import { CheckCircle2, AlertTriangle, XCircle, Loader2, RefreshCw } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ControlDossierRes022({ dossierId, refreshKey }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [verTodos, setVerTodos] = useState(false);

  const revisar = useCallback(async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${API}/control-res022/${dossierId}`);
      setData(res.data);
    } catch {
      setData(null);
    } finally {
      setLoading(false);
    }
  }, [dossierId]);

  useEffect(() => { revisar(); }, [revisar, refreshKey]);

  const problemas = (data?.controles || []).filter((c) => c.estado !== "ok");
  const correctos = (data?.controles || []).filter((c) => c.estado === "ok");
  const { error = 0, aviso = 0 } = data?.resumen || {};
  const color = error ? "border-red-300 bg-red-50" : aviso ? "border-amber-300 bg-amber-50" : "border-emerald-300 bg-emerald-50";

  return (
    <div className={`rounded-lg border p-3 mb-3 ${data ? color : "border-slate-200 bg-slate-50"}`} data-testid="control-dossier">
      <div className="flex items-center gap-2">
        {error ? <XCircle className="w-4 h-4 text-red-600" /> : aviso ? <AlertTriangle className="w-4 h-4 text-amber-600" /> : <CheckCircle2 className="w-4 h-4 text-emerald-600" />}
        <span className="text-sm font-medium flex-1">
          Control del dossier
          {data && <span className="font-normal text-slate-600"> · {error ? `${error} error(es)` : "sin errores"}{aviso ? `, ${aviso} aviso(s)` : ""}</span>}
        </span>
        <button onClick={revisar} disabled={loading} className="inline-flex items-center gap-1 text-xs px-2 py-1 rounded border border-slate-300 bg-white hover:bg-slate-50 disabled:opacity-50">
          {loading ? <Loader2 className="w-3 h-3 animate-spin" /> : <RefreshCw className="w-3 h-3" />}Revisar
        </button>
      </div>
      {problemas.map((c, i) => (
        <p key={i} className={`text-xs mt-1.5 ${c.estado === "error" ? "text-red-700" : "text-amber-700"}`}>
          {c.estado === "error" ? "Error" : "Aviso"} · {c.texto}: {c.detalle}
        </p>
      ))}
      {data && correctos.length > 0 && (
        <button onClick={() => setVerTodos(!verTodos)} className="text-xs text-slate-500 underline mt-1.5">
          {verTodos ? "Ocultar" : "Ver"} los {correctos.length} controles correctos
        </button>
      )}
      {verTodos && correctos.map((c, i) => <p key={i} className="text-xs text-slate-600 mt-0.5">✓ {c.grupo} · {c.texto}</p>)}
    </div>
  );
}
